import { headerItemsConfig } from '../config/headerConfig';
import { HeaderItemType } from '../types/header';
import {
  HeaderIconButton,
  HeaderIconDropdownMenu,
  HeaderIconTextButton,
  HeaderLanguageSelector,
  HeaderIconTextButtonDropdown,
  HeaderAppSwitcher,
} from './HeaderItems';

export const headerComponentMap: Record<HeaderItemType, React.FC<any>> = {
  [HeaderItemType.IconButton]: HeaderIconButton,
  [HeaderItemType.LanguageSelector]: HeaderLanguageSelector,
  [HeaderItemType.IconTextButton]: HeaderIconTextButton,
  [HeaderItemType.IconDropdownMenu]: HeaderIconDropdownMenu,
  [HeaderItemType.IconTextButtonDropdown]: HeaderIconTextButtonDropdown,
  [HeaderItemType.AppSwitcher]: HeaderAppSwitcher,
};

export const DynamicHeader: React.FC = () => {
  return (
    <div className="flex items-center justify-end gap-4 p-1">
      {headerItemsConfig.map((item) => {
        const ComponentToRender = headerComponentMap[item.type];
        return <ComponentToRender key={item.id} {...item} />;
      })}
    </div>
  );
};
